import AdminPanelLayout from "@/layouts/AdminPanelLayout";
import { preLoadProfileInfo } from "@/queries/me";
import type { QueryClient } from "@tanstack/react-query";
import { createBrowserRouter, redirect } from "react-router";
import { ErrorPage } from "@/pages/error";
import Home from "@/pages/home";
import Profile from "@/pages/profile";
import RoleGuard from "@/pages/role-guard";
import type { AxiosError } from "axios";
import { makeHandle } from "./router.helpers";
import { createTramiteRoute } from "./router.tramites";
import { createExpedientesRoutes } from "./router.expedientes";
import { createProcesosRoutes } from "./router.procesos";
import { createCentroDeDatosRoutes } from "./router.centro-de-datos";
import { createPlantillasRoutes } from "./router.plantillas";
import { createRolesRoutes } from "./router.roles";
import { createUsuariosRoutes } from "./router.usuarios";
import { createPortalRoutes } from "./router.portal";
import { createStaticRoutes } from "./router.static";

const createAppRouter = (
  queryClient: QueryClient,
  isSmsEnabled: boolean,
  hasPermission: (permission: string) => boolean,
) => {
  return createBrowserRouter([
    {
      Component: AdminPanelLayout,
      path: "/",
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          Component: () => (
            <RoleGuard permissions={[]}>
              <Home />
            </RoleGuard>
          ),
          handle: makeHandle({ label: "Inicio" }),
        },
        {
          path: "perfil",
          element: <Profile />,
          loader: async () => {
            try {
              return await preLoadProfileInfo(queryClient)();
            } catch (e) {
              const error = e as AxiosError<{ message: string }>;
              if (error.isAxiosError && error.response?.status === 404) {
                throw redirect("/");
              }
              throw e;
            }
          },
          handle: makeHandle({ label: "Mi Perfil" }),
        },
        createProcesosRoutes(queryClient, hasPermission),
        createCentroDeDatosRoutes(queryClient),
        createPlantillasRoutes(isSmsEnabled),
        createRolesRoutes(queryClient),
        createUsuariosRoutes(queryClient),
        createPortalRoutes(),
        createTramiteRoute(queryClient),
        ...createExpedientesRoutes(queryClient),
        ...createStaticRoutes(),
        {
          path: "*",
          loader: () => redirect("/"),
        },
      ],
    },
  ]);
};

export default createAppRouter;
